import { render, staticRenderFns } from "./NoDataSvgComponent.vue?vue&type=template&id=b6a8b68c&"
import script from "./NoDataSvgComponent.vue?vue&type=script&lang=js&"
export * from "./NoDataSvgComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports